<template>
  <div>
    <template>
      <!-- pc的footer -->
      <footer class="weilaidian-footer" v-if="windowWidth > 750">
        <div>
          <div class="footer-content">
            <div class="footer-head">
              <!-- <div class="footer-logoContainer">
                <div class="footer-logo">
                  <img src="@/assets/image/lfLogo.png" alt="" />
                </div>
                <div style="font-size: 0.3rem;color: #fff;margin-left: 0.1rem;padding-right: 0.4rem;">广州市轻膳颜健康科技有限公司</div>
              </div> -->
              <nav class="footer-nav">
                <!-- <ul>
                  <li>
                    <h3>门店入驻</h3>
                  </li>
                  <li
                    v-for="item in storeList.hrefList"
                    :key="item.id"
                    @click.stop="toFlag(item)"
                  >
                    {{ item.minTitle }}
                  </li>
                </ul> -->
                <!-- <ul>
                  <li>
                    <h3>城市分公司</h3>
                  </li>
                  <li
                    v-for="item in cityList.hrefList"
                    :key="item.id"
                    @click.stop="toFlag(item)"
                  >
                    {{ item.minTitle }}
                  </li>
                </ul> -->
                <!-- <ul>
                  <li>
                    <h3>媒体中心</h3>
                  </li>
                  <li
                    v-for="item in newList.hrefList"
                    :key="item.id"
                    @click.stop="toFlag(item)"
                  >
                    {{ item.minTitle }}
                  </li>
                </ul> -->
                <ul>
                  <li @click.stop="home">
                    <h3>首页</h3>
                  </li>
                  <!-- <li v-for="item in MyAbout.hrefList" :key="item.id" @click.stop="toFlag(item)">
                    {{ item.minTitle }}
                  </li> -->
                </ul>
                <ul>
                  <li @click.stop="aboutUs">
                    <h3>关于我们</h3>
                  </li>
                  <!-- <li v-for="item in MyAbout.hrefList" :key="item.id" @click.stop="toFlag(item)">
                    {{ item.minTitle }}
                  </li> -->
                </ul>
                <ul>
                  <li @click.stop="callUs">
                    <h3>联系我们</h3>
                  </li>
                  <!-- <li v-for="item in MyAbout.hrefList" :key="item.id" @click.stop="toFlag(item)">
                    {{ item.minTitle }}
                  </li> -->
                </ul>
              </nav>
              <div class="footer-icon">
                <div class="logo-downLoad">
                  <div class="downLoad-head">微信小程序</div>
                  <div class="downLoad-content">
                    <img src="@/assets/image/qsyxcx.jpg" alt="" />
                  </div>
                </div>
                <div class="weixin-num">
                  <div class="weixin-head">微信公众号</div>
                  <div class="weixin-content">
                    <img src="@/assets/image/qsygzh.jpg" alt="" />
                  </div>
                </div>
              </div>

            </div>
            <div class="footer-foter">
              <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2023141700号-3</a>
              <span style="margin-left: 10px;">Copyright 2025 广州市轻膳颜健康科技有限公司 版权所有 Inc. All Rights Reserved.</span>
              <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011402001122" target="_blank" style="margin-left: 10px;"> <img
                  src="@/assets/image/gongan.png" alt=""> 粤公网安备 号</a>
            </div>
          </div>
        </div>
      </footer>

      <!-- 移动端的footer -->
      <footer class="footer-phone" v-else>
        <!-- <div style="display: flex;align-items: center;">
          <div class="footer-logo">
            <img src="@/assets/image/lfLogo.png" alt="" />
          </div>
          <div style="font-size: 0.3rem;color: #fff;margin-left: 0.1rem;padding-right: 0.4rem;">广州市轻膳颜健康科技有限公司</div>
        </div> -->
        <div class="footer-list" style="margin-top: 0.6rem;">
          <!-- <ul>
            <li>门店入驻</li>
            <li v-for="item in storeList.hrefList" :key="item.id" @click.stop="toFlag(item)">
              {{ item.minTitle }}
            </li>
          </ul> -->
          <!-- <ul>
            <li>城市分公司</li>
            <li v-for="item in cityList.hrefList" :key="item.id" @click.stop="toFlag(item)">
              {{ item.minTitle }}
            </li>
          </ul> -->
          <!-- <ul>
            <li>媒体中心</li>
            <li v-for="item in newList.hrefList" :key="item.id" @click.stop="toFlag(item)">
              {{ item.minTitle }}
            </li>
          </ul> -->
          <ul @click.stop="home">
            <li>首页</li>
            <!-- <li v-for="item in MyAbout.hrefList" :key="item.id" @click.stop="toFlag(item)">
              {{ item.minTitle }}
            </li> -->
          </ul>
          <ul @click.stop="aboutUs">
            <li>关于我们</li>
          </ul>
          <ul @click.stop="callUs">
            <li>联系我们</li>
          </ul>
          <!-- <ul>
            <li>APP下载</li>
            <li>
              <div class="footer-downCode">
                <img src="@/assets/image/wldLogo.png" alt="" />
              </div>
            </li>
          </ul> -->
        </div>
        <div class="footer-message">
          <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2023141700号-3</a>
          <span style="margin-left: 10px;">Copyright © 2025 - 2026 广州市轻膳颜健康科技有限公司 版权所有 Inc. All Rights Reserved.</span>
          <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank" style="margin-left: 10px;"> <img
              src="@/assets/image/gongan.png" alt=""> 粤公网安备 号</a>
        </div>
      </footer>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowWidth: null,
      timer: null,
      storeList: {
        title: '门店入驻',
        hrefList: [
          {
            id: new Date().getTime() + 1,
            minTitle: '门店趋势',
            path: '/storeEnter',
            routerFlag: 't0',
          },
          {
            id: new Date().getTime() + 11,
            minTitle: '平台优势',
            path: '/storeEnter',
            routerFlag: 't1',
          },
          {
            id: new Date().getTime() + 33,
            minTitle: '合作类型',
            path: '/storeEnter',
            routerFlag: 't2',
          },
        ],
      },
      cityList: {
        title: '城市分公司',
        hrefList: [
          {
            id: new Date().getTime() + 99,
            minTitle: '加入我们',
            path: '/cityCompany',
            routerFlag: 't0',
          },
          {
            id: new Date().getTime() + 56,
            minTitle: '门店转型',
            path: '/cityCompany',
            routerFlag: 't1',
          },
          {
            id: new Date().getTime() + 31,
            minTitle: '合作优势',
            path: '/cityCompany',
            routerFlag: 't2',
          },
        ],
      },
      newList: {
        title: '媒体中心',
        hrefList: [
          {
            id: new Date().getTime() + 41,
            minTitle: '新闻动态',
            path: '/newAsync',
            routerFlag: 'newO',
          },
        ],
      },
      MyAbout: {
        title: '关于我们',
        hrefList: [
          {
            id: new Date().getTime() + 254,
            minTitle: '平台介绍',
            path: '/myAbout',
            routerFlag: 't0',
          },
          {
            id: new Date().getTime() + 554,
            minTitle: '平台文化',
            path: '/myAbout',
            routerFlag: 't1',
          },
        ],
      },
    };
  },
  // 获取页面宽度
  created() {
    this.timer = setInterval(() => {
      this.windowWidth = this.WIDTH;
    });
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    toFlag(row) {
      let curRouter = null;
      if (row.path == '/storeEnter') {
        curRouter = 1;
      } else if (row.path == '/cityCompany') {
        curRouter = 2;
      } else if (row.path == '/newAsync') {
        curRouter = 3;
      } else if (row.path == '/myAbout') {
        curRouter = 4;
      }
      window.sessionStorage.setItem('active', curRouter);

      this.$router.push({
        path: row.path,
        query: {
          flag: row.routerFlag,
          time: Date.now(),
        },
      });
    },

    home() {
      this.$router.push({
        path: "/homeView",
        query: {
          index: 0,
        },
      });
    },
    aboutUs() {
      this.$router.push({
        path: "/myAbout",
        query: {
          index: 1,
        },
      });
    },
    callUs() {
      this.$router.push({
        path: "/newAsync",
        query: {
          index: 2,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (min-width:750px) {
  .weilaidian-footer {
    padding: 0.8125rem 0 0.2rem;
    display: flex;
    justify-content: center;
    width: 100%;
    background-color: var(--262626-color);

    .footer-content {
      width: 15.3875rem;
      display: flex;
      flex-direction: column;

      .footer-head {
        display: flex;

        .footer-nav {
          display: flex;
          ul {
            margin-right: 0.825rem;
            li {
              cursor: pointer;
              margin-bottom: 0.4875rem;
              color: var(--B3B3B3-color);
              font-size: 0.2rem;

              &:first-child {
                font-size: 0.225rem;
              }

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }

        .footer-icon {
          display: flex;
          justify-content: center;

          .logo-downLoad {
            margin-right: 0.6875rem;

            .downLoad-head {
              margin-bottom: 0.175rem;
              text-align: center;
              color: var(--B3B3B3-color);
              font-size: 0.225rem;
            }

            .downLoad-content {
              width: 1.6125rem;
              height: 1.6125rem;
              background-color: #ffffff;

              img {
                width: 100%;
              }
            }
          }

          .weixin-num {
            .weixin-head {
              margin-bottom: 0.175rem;
              text-align: center;
              color: var(--B3B3B3-color);
              font-size: 0.225rem;
            }

            .weixin-content {
              width: 1.6125rem;
              height: 1.6125rem;
              background-color: #ffffff;

              img {
                width: 100%;
              }
            }
          }
        }

        .footer-logoContainer {
          margin-left: 0.8875rem;
          display: flex;
          // flex-direction: column;
          align-items: center;
          justify-content: center;

          .footer-logo {
            width: 1rem;
            height: 1rem;

            img {
              width: 100%;
            }
          }

          .logo {
            display: flex;
            justify-items: center;

            .kuwu {
              width: 1.3rem;
              height: 0.65rem;
            }

            .search_kuwu {
              width: 3.9875rem;
              height: 0.5rem;
            }
          }

          .footer-text {
            display: flex;
            margin-top: 0.1875rem;
            color: var(--main-color);
            font-size: 0.275rem;
          }
        }
      }

      .footer-foter {
        font-size: 0.1625rem;
        margin-top: 0.7rem;
        padding-top: 0.2rem;
        border-top: 0.025rem solid #525252;
        border-radius: 0.0125rem;
      }
    }
  }
}

@media screen and (max-width:750px) {
  * {
    max-width: 10rem;
  }

  .footer-phone {
    min-height: 2.8267rem;
    background-color: #262626;

    .footer-logo {
      padding: 0.6rem 0.2933rem 0 0.6267rem;
      width: 2.12rem;
      height: 0.9067rem;
      margin-bottom: 1rem;

      img {
        width: 100%;
      }
    }

    .footer-list {
      padding: 0 0.2933rem 0 0.6267rem;
      display: flex;

      ul {
        margin-right: 0.4rem;
        margin-top: 0.8rem;

        li {
          margin-bottom: 0.5333rem;
          font-size: 0.19rem;
          font-family: DengXian;
          font-weight: 400;
          cursor: pointer;

          .footer-downCode {
            width: 1.72rem;
            height: 1.72rem;

            img {
              width: 100%;
            }
          }
        }

        li:first-child {
          font-size: 0.2133rem;
          // font-size: 0.24rem;
          color: #b3b3b3;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .footer-message {
      border-top: 1px solid #ccc;
      display: flex;
      justify-content: center;
      padding: 0.2667rem 0;
      font-size: 0.14rem !important;

      p:first-child {
        margin-right: 0.4rem;
      }

      img {
        width: 10px;
        height: 10px;
      }

      p {
        font-size: 0.1733rem;
        font-family: DengXian;
        font-weight: 400;
        color: #b3b3b3;
      }
    }
  }
}
</style>
